import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { PageType } from "../../constants";
import { GameConceptIdSearchParam } from "../../helpers/dataFetchingHelpers";
import { AaaGameConceptData } from "../../models/forms";
import { RouteNames } from "../../partnerConfig/routeNames";
import { OnboardingUrls, Paths } from "../../partnerConfig/routes";
import { getGameConceptsList } from "../../redux/selectors";
import { GameConceptState } from "../../server/crm/api/models/forms";
import { AaaCompanyInformationFormPreview } from "./AaaCompanyInformationFormPreview";
import { AaaGameConceptFormPreview } from "./AaaGameConceptFormPreview";
import { FormPreviewContainer } from "./FormPreviewContainer";

type LocationRouteState = {
  applicationId: string;
};

type AaaGameConceptInfoData = {
  id: string;
  gameConceptInfo?: AaaGameConceptData & GameConceptState;
};

const AaaFormPreview = () => {
  const crmGameConceptsList = useSelector(getGameConceptsList);
  const location = useLocation<LocationRouteState>();

  const parseApplicationId = () => {
    if (location?.state && location?.state?.applicationId) {
      return location.state.applicationId;
    }

    if (typeof window !== "undefined" && window.location && window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(GameConceptIdSearchParam) ?? null;
    }

    return null;
  };

  const applicationId = parseApplicationId();
  const [gameConceptInfoData, setGameConceptInfoData] = useState<AaaGameConceptInfoData>();
  const historyElement = useHistory();

  const navigateToAaaWelcomePage = useCallback(
    () => historyElement.replace(OnboardingUrls[RouteNames.AaaWelcome]),
    [historyElement]
  );

  useEffect(() => {
    if (
      (applicationId != null &&
        crmGameConceptsList &&
        Object.keys(crmGameConceptsList).length !== 0 &&
        crmGameConceptsList[applicationId] == null &&
        applicationId !== Paths.IntroInfo) ||
      applicationId == null
    ) {
      navigateToAaaWelcomePage();
    }
  }, [applicationId, crmGameConceptsList, navigateToAaaWelcomePage]);

  useEffect(() => {
    if (applicationId && applicationId !== Paths.IntroInfo) {
      setGameConceptInfoData({
        id: applicationId,
        gameConceptInfo: crmGameConceptsList[applicationId] as AaaGameConceptData &
          GameConceptState,
      });
    }
  }, [applicationId, crmGameConceptsList]);

  return (
    <FormPreviewContainer pageType={PageType.AaaApplication}>
      {applicationId === Paths.IntroInfo && <AaaCompanyInformationFormPreview />}
      {gameConceptInfoData?.gameConceptInfo && (
        <AaaGameConceptFormPreview gameConceptInfo={gameConceptInfoData.gameConceptInfo} />
      )}
    </FormPreviewContainer>
  );
};

export default AaaFormPreview;
